export const SETTLEMENT_PERIOD_INFO = {
  title: 'دوره تسویه',
  description:
    'واریزی شما بر اساس «دوره تسویه» محاسبه می‌شود. هر دوره از ۲۶ام ماه قبل تا ۲۵ام ماه جاری است. پرونده‌هایی که پس از ۲۵ام برای بیمه‌گر ارسال شوند، در دوره تسویه بعد محاسبه خواهند شد.',
  note: ['به طور مثال:', 'دوره تسویه آذر = پرونده‌های ۲۶ آبان تا ۲۵ آذر'],
};

export const UNSETTLED_FILES_INFO = {
  title: 'پرونده‌های تسویه‌نشده',
  description:
    'در این بخش، پرونده‌هایی نمایش داده می‌شوند که در دوره تسویه فعلی برای بیمه‌گر ارسال شده‌اند و مبلغ آن‌ها در همین دوره واریز می‌شود.',
  note: [
    'اگر پرونده‌ای را در این دوره ارزیابی کرده‌اید اما در لیست تسویه مشاهده نمی‌کنید، پرونده هنوز در حال بررسی است و برای بیمه‌گر ارسال نشده است.',
  ],
};
